// hooks/useUserService.ts
import { useUserStore } from "../store/userStore";

export function useUserServices(identifier: string) {
  const users = useUserStore((state) => state.users);

  const userServices = users.filter((user) => {
    return user.email === identifier || user.phone === identifier;
  });

  return userServices.map((user) => ({
    serviceName: user.service_name,
    dateRegistered: user.createdAt,
    location: user.country,
  }));
}
